import { Segment } from 'component/Space/Segment'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { Gender } from 'type/Identity'

type Props = {
  gender: Gender
}

function getLabel(gender: Gender): string {
  switch (gender) {
    case 'female':
      return i18n('gender.Female')
    case 'male':
      return i18n('gender.Male')
  }
}

export const GenderButton = observer(({ gender }: Props) => {
  const { profile } = store

  return <Segment active={profile.gender === gender} action={() => profile.setGender(gender)}>
    {getLabel(gender)}
  </Segment>
})
